import { Box, Button, Typography } from "@mui/material";
import React from "react";
import { Plus } from "../../assets/icons";
import { colors } from "../../styles/color";
import { AddChannelPlus, YoutubeEmpty } from '../../assets/icons';


interface props {
  profileData?: any;
  handleSubmit?: any;
  dashboard?: boolean;
}

export const EmptyYoutubePage = ({
  profileData,
  handleSubmit,
  dashboard,
}: props) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "calc(100vh - 120px)",
        background: colors.dark[800],
        borderRadius: "12px",
        padding: "40px 20px",
        width: "100%",
      }}
    >
   
     

<Box sx={{opacity: 0.3}}>
  <YoutubeEmpty />
</Box>
      {/* Text Message */}
      <Typography
        variant="body1"
        sx={{
          color: colors.gray[300],
          fontSize: "16px",
          fontWeight: "400",
          textAlign: "center",
          marginBottom: "32px",
        }}
      >
        No channel added yet
      </Typography>

      {/* Purple Gradient Button */}
      <Button
        variant="contained"
        startIcon={<AddChannelPlus />}
        onClick={handleSubmit}
       
          sx={{ width: 'fit-content', padding: '0 34px' }} 
        
      >
        Add Channel
      </Button>
    </Box>
  );
};
